<template>
  <div :class="$style.root">
    <div :class="$style.header">
      <h1 :class="$style.title">
        ТОП 100 Метки
      </h1>
      <p :class="$style.subtitle">
        Управление метками для парсинга ТОП 100 видимости
      </p>
    </div>

    <top100-labels-table
      :presets="presetsData"
      :presets-loading="presetsLoading"
      @add="handleAdd"
      @edit="handleEdit"
      @deleted="handleDeleted"
    />

    <modal
      v-model="isModalOpened"
      :title="modalTitle"
      :width="600"
      :primary-button-label="buttonLabel"
      :loading="isLoading"
      @cancel="isModalOpened = false"
      @ok="handleSave"
    >
      <top100-labels-form
        v-model="formValue"
        :presets="presetsData"
        :presets-loading="presetsLoading"
        :error="formError"
        :project-id="projectId"
      />
      <template #bottom>
        <p :class="$style.required">
          {{ $t('hint.all-fields-are-required') }}
        </p>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { PRESET } from '@/store/modules/preset/constants';
import Top100LabelsTable from '../components/Top100LabelsTable';
import Top100LabelsForm from '../components/Top100LabelsForm';
import Modal from '@/ui-kit/Modal';

export default {
  name: 'Top100Labels',
  components: {
    Top100LabelsTable,
    Top100LabelsForm,
    Modal,
  },
  props: {},
  data() {
    return {
      isModalOpened: false,
      formValue: {
        preset_id: null,
        labels_list: [],
      },
      formError: null,
    };
  },
  computed: {
    ...mapGetters('top100Labels', [
      'isLoading',
      'error',
    ]),
    ...mapGetters({
      presets: PRESET.GETTER.LIST,
      createRequest: PRESET.GETTER.CREATE_REQUEST,
      updateRequest: PRESET.GETTER.UPDATE_REQUEST,
    }),
    
    projectId() {
      return this.$route.params.projectId;
    },
    
    presetsData() {
      return this.presets?.data || [];
    },
    
    presetsLoading() {
      return this.presets?.loading || false;
    },
    
    
    modalTitle() {
      return this.formValue.id ? 'Редактировать метки' : 'Добавить метки';
    },
    
    buttonLabel() {
      return this.formValue.id ? this.$t('action.save') : this.$t('action.create');
    },
  },
  watch: {
    projectId() {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('top100Labels', [
      'fetchLabels',
      'createLabel',
      'updateLabel',
    ]),
    ...mapActions({
      getList: PRESET.ACTION.GET_LIST,
    }),
    
    async getData() {
      try {
        await Promise.all([
          this.fetchLabels({ projectId: this.projectId }),
          this.getList(this.projectId),
        ]);
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
      }
    },
    
    refreshData() {
      this.fetchLabels({ projectId: this.projectId });
    },
    
    handleAdd() {
      this.formValue = {
        preset_id: null,
        labels_list: [],
      };
      this.formError = null;
      this.isModalOpened = true;
    },
    
    handleEdit(row) {
      this.formValue = { ...row };
      this.formError = null;
      this.isModalOpened = true;
    },
    
    handleDeleted() {
      this.refreshData();
    },
    
    async handleSave() {
      this.formError = null;
      
      // Валидация формы
      const formComponent = this.$children.find(child => child.$options.name === 'Top100LabelsForm');
      if (formComponent && formComponent.validate) {
        const errors = formComponent.validate();
        if (errors.length > 0) {
          this.formError = errors.join(', ');
          return;
        }
      }
      
      try {
        if (this.formValue.id) {
          console.log('Обновление метки:', {
            projectId: this.projectId,
            labelId: this.formValue.id,
            labelData: {
              labels_list: this.formValue.labels_list,
            },
          });
          await this.updateLabel({
            projectId: this.projectId,
            labelId: this.formValue.id,
            labelData: {
              labels_list: this.formValue.labels_list,
            },
          });
        } else {
          console.log('Создание метки:', {
            projectId: this.projectId,
            labelData: this.formValue,
          });
          await this.createLabel({
            projectId: this.projectId,
            labelData: this.formValue,
          });
        }
      } catch (error) {
        console.error('Ошибка сохранения меток:', error);
        this.formError = error.message || 'Ошибка сохранения меток';
      }
    },
  },
};
</script>

<style lang="scss" module>
@import "~@/ui-kit/_theme/main.scss";

.root {
  padding: $gap-m;
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  margin-bottom: $gap-l;
}

.title {
  font-size: 28px;
  font-weight: 600;
  color: $text-primary-color;
  margin: 0 0 $gap-s 0;
}

.subtitle {
  font-size: 16px;
  color: $text-secondary-color;
  margin: 0;
}

.required {
  color: $text-secondary-color;
  font-size: 14px;
  margin: 0;
}
</style>
